import React, { memo } from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { PieChartData } from './utils';
import { useLabelStyles } from './hooks/useLabelStyles';

type ProgramComponentProps = {
  data: PieChartData;
  loading: boolean;
  isEmpty: boolean;
  setGetCurrentPage?: React.Dispatch<React.SetStateAction<number>> | undefined;
};

export const ProgramComponent: React.FC<ProgramComponentProps> = ({
  data,
  loading,
  isEmpty,
  setGetCurrentPage
}: ProgramComponentProps) => {
  const classes = useLabelStyles();
  const name = useMessage('insights.timeSheetLabels.programs');
  return (
    <Paper
      elevation={3}
      data-testid={'source-by-program-chart-container'}
      className={classes.container}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="h6"
            data-testid="program-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart
              data={data}
              labelType="PROGRAM"
              setGetCurrentPage={setGetCurrentPage}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(ProgramComponent);
